
import comparisonScrollController from './comparisonscrollcontroller';
import comparisonTable from './comparisontable';
import comparisonTools from './comparisontools';
import productFilterModal from './productfiltermodal';
import productFilters from './productfilters';

const $container = document.getElementById('comparison-chart-container');
const $filterContainer = document.getElementById('comparison-filter');
const $table = $container.querySelector('table');

const scrollController = comparisonScrollController({
    $scrollarea: $container.querySelector('.compare-scroll-container'),
    $columns: [...$table.querySelector('tr').querySelectorAll('td, th')],
    $next: $container.querySelector('.control-scroll-next'),
    $previous: $container.querySelector('.control-scroll-previous')
});

const productTable = comparisonTable($table);
const tools = comparisonTools($container);
const filters = productFilters($filterContainer);
const productIDs = productTable.getProductIds();
const params = new URLSearchParams(location.search);

const updateIds = ids => {
    productTable.showIds(ids);
    tools.setFiltersInURL(ids.length && ids.length !== productIDs.length ? ids : undefined);
    scrollController.forceUpdate();
};

if (params.has('filters')) {
    const ids = decodeURIComponent(params.get('filters')).split(',');
    filters.setSelectedValues(ids);
    updateIds(ids);
}

$container.querySelector('.filter-button')?.addEventListener('click', () => {
    const initialFilterValues = filters.getSelectedValues();

    productFilterModal($filterContainer, {
        onApply: () => {
            const selectedProductIds = filters.getSelectedValues();
            const hasSelectedFilters = selectedProductIds.length > 0;

            if (hasSelectedFilters) {
                updateIds(selectedProductIds);
            }

            return hasSelectedFilters;
        },
        onCancel: () => filters.setSelectedValues(initialFilterValues)
    });
});
